module.exports = __webpack_public_path__ + "img/icon-info-blue.dfff1bd0.svg";